import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Chatbotuserrights extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.chatbotuserrights_Id,
          sortable: true,
          cell: (row) => <span>{row.chatbotuserrights_Id}</span>,
        },
        { name: "User Id", selector: (row, i) => row.user_Id, sortable: true, cell: (row) => <span>{row.user_Id}</span>, }, { name: "Can Access Chatbot", selector: (row, i) => row.can_access_chatbot, sortable: true, cell: (row) => <span>{row.can_access_chatbot}</span>, }, { name: "Can Access Quotes", selector: (row, i) => row.can_access_quotes, sortable: true, cell: (row) => <span>{row.can_access_quotes}</span>, }, { name: "Can Access Policies", selector: (row, i) => row.can_access_policies, sortable: true, cell: (row) => <span>{row.can_access_policies}</span>, }, { name: "Can Access Claims", selector: (row, i) => row.can_access_claims, sortable: true, cell: (row) => <span>{row.can_access_claims}</span>, }, { name: "Can Access Reports", selector: (row, i) => row.can_access_reports, sortable: true, cell: (row) => <span>{row.can_access_reports}</span>, }, { name: "Can Access Admin", selector: (row, i) => row.can_access_admin, sortable: true, cell: (row) => <span>{row.can_access_admin}</span>, }, { name: "Can Train Bot", selector: (row, i) => row.can_train_bot, sortable: true, cell: (row) => <span>{row.can_train_bot}</span>, }, { name: "Can View Analytics", selector: (row, i) => row.can_view_analytics, sortable: true, cell: (row) => <span>{row.can_view_analytics}</span>, }, { name: "Max Daily Queries", selector: (row, i) => row.max_daily_queries, sortable: true, cell: (row) => <span>{row.max_daily_queries}</span>, }, { name: "Priority Level", selector: (row, i) => row.priority_level, sortable: true, cell: (row) => <span>{row.priority_level}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.ChatbotuserrightseditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      chatbotuserrights_Id: "",
      users: [], user_Id: '', can_access_chatbot: '', can_access_quotes: '', can_access_policies: '', can_access_claims: '', can_access_reports: '', can_access_admin: '', can_train_bot: '', can_view_analytics: '', max_daily_queries: '', testcaseprioritymaster: [], priority_level: '',
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined


    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'user_Id', inputType: 'Select', displayName: 'User Id', validationOptions: { isRequired: false } },
      { fieldName: 'can_access_chatbot', inputType: 'Number', displayName: 'Can Access Chatbot', validationOptions: { isRequired: false } },
      { fieldName: 'can_access_quotes', inputType: 'Number', displayName: 'Can Access Quotes', validationOptions: { isRequired: false } },
      { fieldName: 'can_access_policies', inputType: 'Number', displayName: 'Can Access Policies', validationOptions: { isRequired: false } },
      { fieldName: 'can_access_claims', inputType: 'Number', displayName: 'Can Access Claims', validationOptions: { isRequired: false } },
      { fieldName: 'can_access_reports', inputType: 'Number', displayName: 'Can Access Reports', validationOptions: { isRequired: false } },
      { fieldName: 'can_access_admin', inputType: 'Number', displayName: 'Can Access Admin', validationOptions: { isRequired: false } },
      { fieldName: 'can_train_bot', inputType: 'Number', displayName: 'Can Train Bot', validationOptions: { isRequired: false } },
      { fieldName: 'can_view_analytics', inputType: 'Number', displayName: 'Can View Analytics', validationOptions: { isRequired: false } },
      { fieldName: 'max_daily_queries', inputType: 'Number', displayName: 'Max Daily Queries', validationOptions: { isRequired: false } },
      { fieldName: 'priority_level', inputType: 'Select', displayName: 'Priority Level', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });

  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      users: [], user_Id: '', can_access_chatbot: '', can_access_quotes: '', can_access_policies: '', can_access_claims: '', can_access_reports: '', can_access_admin: '', can_train_bot: '', can_view_analytics: '', max_daily_queries: '', testcaseprioritymaster: [], priority_level: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      users: [], user_Id: '', can_access_chatbot: '', can_access_quotes: '', can_access_policies: '', can_access_claims: '', can_access_reports: '', can_access_admin: '', can_train_bot: '', can_view_analytics: '', max_daily_queries: '', testcaseprioritymaster: [], priority_level: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  ChatbotuserrightseditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      chatbotuserrights_Id: row.chatbotuserrights_Id,
      users: [], user_Id: row.user_Id, can_access_chatbot: row.can_access_chatbot, can_access_quotes: row.can_access_quotes, can_access_policies: row.can_access_policies, can_access_claims: row.can_access_claims, can_access_reports: row.can_access_reports, can_access_admin: row.can_access_admin, can_train_bot: row.can_train_bot, can_view_analytics: row.can_view_analytics, max_daily_queries: row.max_daily_queries, testcaseprioritymaster: [], priority_level: row.priority_level,
      //***editstate
      errors: {},
      touched: {}
    });
  }

  ChatbotuserrightsfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Chatbotuserrights/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  ChatbotuserrightssubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('user_Id', this.state.user_Id);
    formData.append('can_access_chatbot', this.state.can_access_chatbot);
    formData.append('can_access_quotes', this.state.can_access_quotes);
    formData.append('can_access_policies', this.state.can_access_policies);
    formData.append('can_access_claims', this.state.can_access_claims);
    formData.append('can_access_reports', this.state.can_access_reports);
    formData.append('can_access_admin', this.state.can_access_admin);
    formData.append('can_train_bot', this.state.can_train_bot);
    formData.append('can_view_analytics', this.state.can_view_analytics);
    formData.append('max_daily_queries', this.state.max_daily_queries);
    formData.append('priority_level', this.state.priority_level);

    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Chatbotuserrights/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ChatbotuserrightsfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ users: [], user_Id: '', can_access_chatbot: '', can_access_quotes: '', can_access_policies: '', can_access_claims: '', can_access_reports: '', can_access_admin: '', can_train_bot: '', can_view_analytics: '', max_daily_queries: '', testcaseprioritymaster: [], priority_level: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  ChatbotuserrightsupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("chatbotuserrights_Id", this.state.chatbotuserrights_Id);
    formData.append('user_Id', this.state.user_Id);
    formData.append('can_access_chatbot', this.state.can_access_chatbot);
    formData.append('can_access_quotes', this.state.can_access_quotes);
    formData.append('can_access_policies', this.state.can_access_policies);
    formData.append('can_access_claims', this.state.can_access_claims);
    formData.append('can_access_reports', this.state.can_access_reports);
    formData.append('can_access_admin', this.state.can_access_admin);
    formData.append('can_train_bot', this.state.can_train_bot);
    formData.append('can_view_analytics', this.state.can_view_analytics);
    formData.append('max_daily_queries', this.state.max_daily_queries);
    formData.append('priority_level', this.state.priority_level);

    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Chatbotuserrights/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ChatbotuserrightsfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.ChatbotuserrightsfetchHandler();
    this.usersfetchHandler();
    this.testcaseprioritymasterfetchHandler();

    //***componentDidMount
  }

  handleuser_IdChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ user_Id: fieldValue });
  }; usersfetchHandler = () => {
    fetch(configData.api_url + "C_Users/list", {  // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ users: data.list });
        }
      });
  }; handlecan_access_chatbotChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ can_access_chatbot: fieldValue });
  }; handlecan_access_quotesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ can_access_quotes: fieldValue });
  }; handlecan_access_policiesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ can_access_policies: fieldValue });
  }; handlecan_access_claimsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ can_access_claims: fieldValue });
  }; handlecan_access_reportsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ can_access_reports: fieldValue });
  }; handlecan_access_adminChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ can_access_admin: fieldValue });
  }; handlecan_train_botChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ can_train_bot: fieldValue });
  }; handlecan_view_analyticsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ can_view_analytics: fieldValue });
  }; handlemax_daily_queriesChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ max_daily_queries: fieldValue });
  }; handlepriority_levelChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ priority_level: fieldValue });
  }; testcaseprioritymasterfetchHandler = () => {
    fetch(configData.api_url + "C_Testcaseprioritymaster/list", {  // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ testcaseprioritymaster: data.list });
        }
      });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this chatbotuserrights?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('chatbotuserrights_Id', row.chatbotuserrights_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Chatbotuserrights/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ChatbotuserrightsfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Chatbot User Rights</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Chatbotuserrights</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>User Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select className="form-select" name="tableName" onChange={this.handleuser_IdChange}>
                                        <option defaultValue> Select User Id </option>
                                        {this.state.users.map((api, index, idx) => (
                                          <option key={index} value={api.users_Id}> {api.users_Id} </option>
                                        ))}
                                      </select>
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.user_Id} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Can Access Chatbot</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlecan_access_chatbotChange} className="form-control" name="can_access_chatbot" value={this.state.can_access_chatbot} required="required" placeholder="Enter Can Access Chatbot" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_access_chatbot} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Can Access Quotes</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlecan_access_quotesChange} className="form-control" name="can_access_quotes" value={this.state.can_access_quotes} required="required" placeholder="Enter Can Access Quotes" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_access_quotes} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Can Access Policies</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlecan_access_policiesChange} className="form-control" name="can_access_policies" value={this.state.can_access_policies} required="required" placeholder="Enter Can Access Policies" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_access_policies} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Can Access Claims</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlecan_access_claimsChange} className="form-control" name="can_access_claims" value={this.state.can_access_claims} required="required" placeholder="Enter Can Access Claims" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_access_claims} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Can Access Reports</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlecan_access_reportsChange} className="form-control" name="can_access_reports" value={this.state.can_access_reports} required="required" placeholder="Enter Can Access Reports" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_access_reports} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Can Access Admin</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlecan_access_adminChange} className="form-control" name="can_access_admin" value={this.state.can_access_admin} required="required" placeholder="Enter Can Access Admin" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_access_admin} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Can Train Bot</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlecan_train_botChange} className="form-control" name="can_train_bot" value={this.state.can_train_bot} required="required" placeholder="Enter Can Train Bot" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_train_bot} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Can View Analytics</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlecan_view_analyticsChange} className="form-control" name="can_view_analytics" value={this.state.can_view_analytics} required="required" placeholder="Enter Can View Analytics" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_view_analytics} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Max Daily Queries</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlemax_daily_queriesChange} className="form-control" name="max_daily_queries" value={this.state.max_daily_queries} required="required" placeholder="Enter Max Daily Queries" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.max_daily_queries} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Priority Level</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select className="form-select" name="tableName" onChange={this.handlepriority_levelChange}>
                                        <option defaultValue> Select Priority Level </option>
                                        {this.state.testcaseprioritymaster.map((api, index, idx) => (
                                          <option key={index} value={api.low}> {api.low} </option>
                                        ))}
                                      </select>
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.priority_level} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.ChatbotuserrightssubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Chatbotuserrights</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>User Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select className="form-select" name="tableName" onChange={this.handleuser_IdChange}>
                                          <option defaultValue> Select User Id </option>
                                          {this.state.users.map((api, index, idx) => (
                                            <option key={index} value={api.users_Id}> {api.users_Id} </option>
                                          ))}
                                        </select>
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.user_Id} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Can Access Chatbot</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlecan_access_chatbotChange} className="form-control" name="can_access_chatbot" value={this.state.can_access_chatbot} required="required" placeholder="Enter Can Access Chatbot" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_access_chatbot} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Can Access Quotes</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlecan_access_quotesChange} className="form-control" name="can_access_quotes" value={this.state.can_access_quotes} required="required" placeholder="Enter Can Access Quotes" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_access_quotes} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Can Access Policies</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlecan_access_policiesChange} className="form-control" name="can_access_policies" value={this.state.can_access_policies} required="required" placeholder="Enter Can Access Policies" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_access_policies} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Can Access Claims</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlecan_access_claimsChange} className="form-control" name="can_access_claims" value={this.state.can_access_claims} required="required" placeholder="Enter Can Access Claims" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_access_claims} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Can Access Reports</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlecan_access_reportsChange} className="form-control" name="can_access_reports" value={this.state.can_access_reports} required="required" placeholder="Enter Can Access Reports" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_access_reports} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Can Access Admin</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlecan_access_adminChange} className="form-control" name="can_access_admin" value={this.state.can_access_admin} required="required" placeholder="Enter Can Access Admin" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_access_admin} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Can Train Bot</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlecan_train_botChange} className="form-control" name="can_train_bot" value={this.state.can_train_bot} required="required" placeholder="Enter Can Train Bot" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_train_bot} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Can View Analytics</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlecan_view_analyticsChange} className="form-control" name="can_view_analytics" value={this.state.can_view_analytics} required="required" placeholder="Enter Can View Analytics" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.can_view_analytics} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Max Daily Queries</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlemax_daily_queriesChange} className="form-control" name="max_daily_queries" value={this.state.max_daily_queries} required="required" placeholder="Enter Max Daily Queries" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.max_daily_queries} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Priority Level</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select className="form-select" name="tableName" onChange={this.handlepriority_levelChange}>
                                          <option defaultValue> Select Priority Level </option>
                                          {this.state.testcaseprioritymaster.map((api, index, idx) => (
                                            <option key={index} value={api.low}> {api.low} </option>
                                          ))}
                                        </select>
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.priority_level} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.ChatbotuserrightsupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}